import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import ProjectCategoryService from '../services/ProjectCategoryService';
import ColorPickerComponent from '../components/inputs/ColorPickerComponent';

class ProjectCategoryEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new ProjectCategoryService());
        this.state = {
            elementId: props.elementId,
            element: {
                name: '',                
                color: {value: ""} ,                
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            },
            viewMode: this.props.viewMode,
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('projectCategory.addButton') : t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }
   
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('projectCategory.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                            ? `${t('projectCategory.editHeader')}`
                            : this.state.viewMode === 'DELETE'
                            ? `${t('projectCategory.deleteHeader')}`
                            : null}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }

    getAddSucces() {
        const {t} = this.props;
        return t('projectCategory.addSuccess');
    }
  
    getUpdateSucces() {
        const {t} = this.props;
        return t('projectCategory.updateSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            }
        }
    }

    renderDetails() {
        return  (
            <React.Fragment>
                <DivContainer colClass='row'>
                <InputTextComponent
                    id='name'
                    name='name'
                    label={'Nazwa'}
                    colClass='col-md-12'
                    value={this.state.element.name}
                    validator={this.validator}
                    validators='required|max:255'
                    onChange={this.handleChange}
                    viewMode={'EDIT'}                        
                 />
                  <ColorPickerComponent  
                    componentClassName = "col-12 mt-2"
                    value={this.state.element.color.value}
                    label={'Wybór koloru'}
                    viewMode={"EDIT"}
                    onChange={(e)=>{
                        this.setState((prevState)=>({
                            element:{
                                ...prevState.element,
                                color:{value: e.value}
                            }
                        }))
                    }}
                 />
                </DivContainer>
            </React.Fragment>
        );
    }
}

ProjectCategoryEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

ProjectCategoryEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    roleTypes: PropTypes.object,
    className: PropTypes.string
};

export default withTranslation()(ProjectCategoryEditDialog);
